/**
 * Region search order for an element hit by a click.
 *
 * `element.regionIds` is the element's full region membership as written by the
 * conversor, in arbitrary order. Insertion flows walk that list and take the
 * first loaded region that owns a copy of the element, so the region that owns
 * the clicked (visible) copy — `element.regionId` — has to come first. Otherwise,
 * with a neighbouring region also loaded but hidden, the new point is filed
 * under the hidden region and never shows up.
 */
export function regionIdsForClickedElement(element: { regionId?: string; regionIds?: Array<string> }): Array<string> {
  const owner = element?.regionId;
  const memberships = element?.regionIds ?? [];
  if (!owner) return element?.regionIds;
  return [owner, ...memberships.filter(regionId => regionId !== owner)];
}
